import { defineMessages } from 'react-intl';

export const recommendedSeatBadgeMessages = defineMessages({
  recommended: {
    id: 'I8qEdzaMJ9',
    defaultMessage: 'Recommended',
    description: 'Badge on the Max seat option, shown when the team’s usage is high',
  },
  recommendedTooltip: {
    id: 'ibj+V8XoBf',
    defaultMessage: 'Based on your usage this month',
    description:
      'Tooltip on the Recommended badge explaining the Max seat is suggested from the team’s credit usage this month',
  },
});
